import { AfterViewInit, Component, ElementRef, Inject, Input, OnChanges, OnDestroy, SimpleChanges, Type, ViewEncapsulation } from '@angular/core';
import { ScrollService } from '../scroll/scroll.service';
import { DOCUMENT } from '@angular/common';
import { GridOptions } from 'ag-grid-community';
import { util } from '../util';
import { GaAgGridService } from './ga-ag-grid.service';
import { IObject } from '@type_definitions/datatypes';

export enum CellRendererComp {
  REPORT_DOCUMENT_RENDERER = 'agReportDocumentRenderer',
  SELECT_HEADER = 'agSelectHeader',
  CONTACT_INFO_RENDERER = 'agContactInfoRenderer',
  BUTTON_DROPDOWN_RENDERER = 'agButtonDropdownRenderer',
  ACTION_BUTTON_RENDERER = 'agActionButtonRenderer',
  BUTTON_RENDERER ='agButtonRenderer',
  RICH_TEXT_RENDERER = 'agRichTextRenderer',
  DETAIL = 'agDetail',
  TOOLTIP = 'agTooltip',
  CELL_EDITOR = 'agCellEditor',
  PAGINATION = 'agPagination',

  // default from ag-grid
  GROUP_CELL_RENDERER = 'agGroupCellRenderer'
}

@Component({
  selector: 'ga-ag-grid',
  template: `
    <ag-grid-angular class="ag-theme-quartz report-grid" style="height: 100%" [gridOptions]="gridOptions" [components]="components" *ngIf="gridInit"></ag-grid-angular>
  `,
  styleUrls: ['./ga-ag-grid.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GaAgGridComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() public height:number;
  @Input() public gridId?:string;
  @Input() public gridInit:boolean;
  @Input() public gridOptions:GridOptions;

  public components:IObject<Type<any>>;

  private gridElement:JQuery<HTMLElement>;

  constructor(
    private elementRef:ElementRef,
    private scrollService:ScrollService,
    private gaAgGridService:GaAgGridService,
    @Inject(DOCUMENT) private document:Document,
    @Inject(Window) private window:Window
  ) {
    /**/
  }

  public ngOnChanges(changes:SimpleChanges) {
    if (changes.gridId) {
      this.gridId = changes.gridId.currentValue;
    }

    if (changes.gridOptions?.currentValue) {
      this.gridOptions = changes.gridOptions.currentValue;

      // install grid instance
      if (this.gridId) {
        this.gaAgGridService.install(this.gridId, this.gridOptions);
      }

      // register custom cell renderer ag-grid components
      this.components = this.gaAgGridService.getCustomAgGridComponents(this.gridOptions);
    }
  }

  public ngAfterViewInit():void {
    this.gridElement = $(this.elementRef.nativeElement);
    this.gridElement.css('display', 'block');

    if (util.notNullOrUndefined(this.height)) {
      this.gridElement.height(this.height);
    }

    // adjust scrolling
    this.adjustScrolling();
  }

  private adjustScrolling():void {
    this.gridElement.on('mousewheel', this.onMouseWheel);
  }

  //do not scroll in the grid when the page isn't fully scrolled to bottom yet
  private onMouseWheel = (event:any) => {
    const scrollTop:number = this.scrollService.scrollTop();
    // -5: allow for some wiggle room (sometimes scrollTop is fractional)
    const scrollMax:number = this.document.documentElement.clientHeight - $(this.window).height() - 5;

    // if only horizontal scrolling, don't prevent
    if (event.deltaY
      // when not near the bottom of the page
      && scrollTop < scrollMax) {

      event.preventDefault();
      //apply it to the document instead
      const distanceY:number = event.deltaY * event.deltaFactor;
      this.scrollService.scrollTop(scrollTop - distanceY);
    }
  };

  public ngOnDestroy():void {
    this.gaAgGridService.destroyGridInstance(this.gridId);
  }
}